import moment from 'moment-timezone';

export default function (dateTime) {
    if (!dateTime) { return null; }

    return !moment.unix(dateTime).isValid() ? Number(Math.floor(new Date(dateTime).getTime() / 1000)) : dateTime;
}
